export const sampleData = [
    {
        holding: 'Financials',
        allocation: 0.2,
        allocationFormatted: '20.00%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Industrials',
        allocation: 0.148,
        allocationFormatted: '14.80%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Information Technology',
        allocation: 0.136,
        allocationFormatted: '13.60%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Health Care',
        allocation: 0.135,
        allocationFormatted: '13.50%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Consumer Staples',
        allocation: 0.11,
        allocationFormatted: '11.00%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Consumer Discretionary',
        allocation: 0.065,
        allocationFormatted: '6.50%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Communication Services',
        allocation: 0.06,
        allocationFormatted: '6.00%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Materials',
        allocation: 0.038,
        allocationFormatted: '3.80%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Real Estate',
        allocation: 0.023,
        allocationFormatted: '2.30%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
    {
        holding: 'Cash and Equivalents',
        allocation: 0.085,
        allocationFormatted: '8.50%',
        sortOrder: 0,
        exclude: null,
        targetIdPrefix: null,
    },
];
